import script from "./DayButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayButton.vue?vue&type=script&setup=true&lang=ts"

import "./DayButton.vue?vue&type=style&index=0&id=19c71f7a&lang=css"

const __exports__ = script;

export default __exports__